// Tech Stack 😁
import react from "./TechStack/react.png";
import css from "./TechStack/css.png";
import fastapi from "./TechStack/fastapi.png";
import git from "./TechStack/git.png";
import python from "./TechStack/python.png";
import jwt from "./TechStack/jwt.png";
import postgresql from "./TechStack/postgresql.png";
import javascript from "./TechStack/javascript.png";

// Mockups 📱
import mockup_1 from "./Mockups/mockup_1.png";
import mockup_2 from "./Mockups/mockup_2.png";
import mockup_3 from "./Mockups/mockup_3.png";
import mockup_4 from "./Mockups/mockup_4.png";
import mockup_5 from "./Mockups/mockup_5.png";

// Logos 🔣
import expo from "./Logos/expo.png";

const assets = {
  // Tech Stack Export
  react,
  css,
  fastapi,
  git,
  python,
  jwt,
  postgresql,
  javascript,
  // Mockups Export
  mockup_1,
  mockup_2,
  mockup_3,
  mockup_4,
  mockup_5,
  // Logos
  expo,
};

// Exporting assets 😁
export default assets;
